import { useEffect, useState } from 'react';
import { projectId, publicAnonKey } from '/utils/supabase/info';

/**
 * True when `tension_admin_session` exists and passes `/admin/validate-session`.
 * Allows admin panel access without Supabase `admin` role (legacy session compatibility flow).
 */
export function useLegacyAdminSessionValid(): { valid: boolean; loading: boolean } {
  const [state, setState] = useState<{ valid: boolean; loading: boolean }>({
    valid: false,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (typeof localStorage === 'undefined') {
        setState({ valid: false, loading: false });
        return;
      }
      const stored = localStorage.getItem('tension_admin_session');
      if (!stored) {
        setState({ valid: false, loading: false });
        return;
      }
      try {
        const { sessionToken } = JSON.parse(stored) as { sessionToken?: string };
        if (!sessionToken) {
          setState({ valid: false, loading: false });
          return;
        }
        const response = await fetch(
          `https://${projectId}.supabase.co/functions/v1/make-server-ba6cedc4/admin/validate-session`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${publicAnonKey}`,
            },
            body: JSON.stringify({ sessionToken }),
          },
        );
        const raw = await response.text();
        let data: { valid?: boolean } = {};
        if (raw) {
          try {
            data = JSON.parse(raw) as { valid?: boolean };
          } catch {
            data = {};
          }
        }
        if (cancelled) return;
        if (data.valid) {
          setState({ valid: true, loading: false });
        } else {
          localStorage.removeItem('tension_admin_session');
          setState({ valid: false, loading: false });
        }
      } catch {
        if (!cancelled) setState({ valid: false, loading: false });
      }
    };

    void run();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
